import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202603",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 38753,
  clicks: 782,
  adsSpendDollars: 2281,
  budgetDollars: 2300,
  salesDollars: 7679,
  bestEstimateRoas: 3.37,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.99,
  newCustomersAcquired: 15,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
